import axios from "axios"
import { API_BASE_URL } from "../config"

export const manageFacilityCreate = async (name: string, address: string, phone: string, building_type: number) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/facility/create`, {
        session_code: localStorage.getItem("session_code"),
        name: name,
        address: address,
        phone: phone,
        building_type: building_type
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }
      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
